import {
  CheckIcon,
  Divider,
  Grid2,
  HashIcon,
  MfSuccessIcon,
  PhoneIcon,
  StatusField,
  Typography,
} from "components";
import { useLocation } from "react-router-dom";

const MfOnboardingCompleteStatus = () => {
  const location = useLocation();

  const clientData = location.state?.clientData;

  const logo = location.search.split("logo=")[1];

  return (
    <Grid2
      container
      direction="column"
      style={{
        minHeight: "100vh",
        width: "100%",
        background: "#fff",
      }}
    >
      <Grid2 container justifyContent="center" style={{ flex: 1 }}>
        <Grid2
          size={{ xs: 12, md: 6 }}
          py={4}
          px={2}
          sx={{ maxWidth: "580px" }}
        >
          <Grid2
            size={12}
            display="flex"
            flexDirection="column"
            alignItems="center"
            p={2}
            gap={1}
          >
            <MfSuccessIcon />
            <Typography fontSize={16} fontWeight={700} color="var(--grey-900)">
              You&apos;re all done!
            </Typography>
            <Typography fontSize={12} fontWeight={500} color="var(--grey-600)">
              All steps are complete. Feel free to close this tab.
            </Typography>
          </Grid2>
          <Grid2
            size={12}
            borderRadius={1.5}
            bgcolor={"#F8F8F8"}
            p={1.5}
            mt={4}
          >
            <Typography fontSize={20} fontWeight={700} mb={0.5}>
              {clientData?.personalDetails?.name || ""}
            </Typography>

            <Grid2 size={12}>
              <Grid2 container gap={1} alignItems={"center"}>
                <Grid2
                  container
                  gap={1}
                  alignItems={"center"}
                  size={{ xs: 12, md: "auto" }}
                >
                  <PhoneIcon color="var(--grey-500)" />

                  <Typography
                    fontSize={12}
                    fontWeight={500}
                    color={"var(--grey-500)"}
                  >
                    Phone No:
                  </Typography>

                  <Typography
                    fontSize={12}
                    fontWeight={600}
                    color={"var(--neutral-700)"}
                  >
                    {clientData?.phone || ""}
                  </Typography>
                </Grid2>

                <Grid2
                  size={{ xs: 12, md: "auto" }}
                  sx={{ display: { xs: "none", md: "block" } }}
                >
                  <Divider orientation="vertical" flexItem />
                </Grid2>

                <Grid2
                  container
                  gap={1}
                  alignItems={"center"}
                  size={{ xs: 12, md: "auto" }}
                >
                  <HashIcon color="var(--grey-500)" />

                  <Typography
                    fontSize={12}
                    fontWeight={400}
                    color={"var(--grey-500)"}
                  >
                    Client Code:
                  </Typography>

                  <Typography
                    fontSize={12}
                    fontWeight={600}
                    color={"var(--neutral-700)"}
                  >
                    {clientData?.code || ""}
                  </Typography>
                </Grid2>
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2 size={12} mt={4} py={1}>
            <Grid2 container alignItems={"center"} gap={1}>
              <CheckIcon />

              <Typography
                width={"134px"}
                fontSize={12}
                fontWeight={500}
                color="var(--grey-500)"
              >
                Basket Name:
              </Typography>

              <Typography
                fontSize={12}
                fontWeight={600}
                color="var(--neutral-700)"
              >
                {clientData?.basket?.name || ""}
              </Typography>

              <Divider style={{ borderStyle: "dashed", borderColor: "#ccc" }} />

              <Grid2 size={12} py={1}>
                <Grid2 container alignItems={"center"} gap={1}>
                  <CheckIcon />

                  <Typography
                    width={"134px"}
                    fontSize={12}
                    fontWeight={500}
                    color="var(--grey-500)"
                  >
                    MF Investor Readiness:
                  </Typography>

                  <StatusField statusString="Completed" />
                </Grid2>
              </Grid2>
            </Grid2>
          </Grid2>
          <Grid2 size={12} mt={4} pt={3}>
            <Grid2
              container
              flexDirection="column"
              textAlign={"center"}
              alignItems={"center"}
              justifyContent={"center"}
              gap={1}
            >
              <Typography
                fontSize={12}
                fontWeight={500}
                color="var(--grey-500)"
              >
                We look forward to growing with you.
              </Typography>
              <img
                src={logo || "/Logos/iconFullLogo.png"}
                alt=""
                height={`-webkit-fill-available`}
                width={"auto"}
                style={{ maxHeight: "32px" }}
                onError={({ currentTarget }) => {
                  currentTarget.src =
                    "https://gridkey.in/Logos/iconFullLogo.png";
                }}
              />
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default MfOnboardingCompleteStatus;
